export const inputBackgroundClasses = {
    primary: 'bg-slate-50 dark:bg-neutral-800 focus:border-accent-500',
    secondary: 'bg-slate-25 dark:bg-neutral-900 focus:border-accent-500',
    danger: 'bg-danger-50 dark:bg-danger-950/60 focus:border-danger-600',
    transparent: 'bg-transparent',
};
